module.exports = __webpack_public_path__ + "static/gallery-img-8-d8c0eca511ce59fa42cbe248296740cf.jpg";